// components/BookingTabs.tsx
import React from "react";
import { Tabs, Tab, Box } from "@mui/material";

interface BookingTabsProps {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

const BookingTabs: React.FC<BookingTabsProps> = ({ selectedTab, setSelectedTab }) => {
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        mb: 2,
        mt: 2,
        width: "100%",
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label="Booking tabs"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          "& .MuiTab-root": {
            fontSize: "16px",
            textTransform: "none",
            fontFamily: "Karbon-medium",
            minWidth: "auto",
            px: 2,
          },
          "& .MuiTabs-indicator": {
            height: "3px",
          },
        }}
      >
        <Tab label="Booking (Pending Confirmation)" value="booking" />
        <Tab label="Upcoming (Confirmed/Rescheduled)" value="scheduled" />
        <Tab label="Completed" value="completed" />
        <Tab label="Missed/Lapsed" value="missed" />
        <Tab label="Cancelled" value="cancelled" />
      </Tabs>
    </Box>
  );
};

export default BookingTabs;
